import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0C3Y68eiDLY7XB80zuZvkPeXyY3qUmw8",
  authDomain: "web-week-chatapp.firebaseapp.com",
  projectId: "web-week-chatapp",
  storageBucket: "web-week-chatapp.appspot.com",
  messagingSenderId: "784610329555",
  appId: "1:784610329555:web:d2f400e625cff221cce526",
  measurementId: "G-VVLEH3MG27",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app(); // if already initialized, use that one
}

export default firebase;
